module.exports = __webpack_public_path__ + "static/media/check-24px.c3f045db.svg";